import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {topicsData.title}
          </h2>
          <p className="text-sm text-foreground-600">全网热议话题一站掌握</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.items.map((item) => (
            <span
              key={item.name}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium cursor-pointer transition-colors ${
                item.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {item.hot && <i className="ri-fire-line text-primary-500 text-xs"></i>}
              {item.name}
              <span className={`text-xs ${item.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                {item.count}
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}